<template>
  <vs-checkbox v-model="selected" :disabled="!hasPermission('life.admin.roles.edit')" color="primary" />
</template>

<script>
export default {
  components: {},
  props: [
    "permission",
    "userGlobalPermissions",
    "userEntityPermissions",
    "addGlobalPermission",
    "removeGlobalPermission",
    "addEntityPermission",
    "removeEntityPermission",
  ],
  data() {
    return { selected: false };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.selected =
      this.userEntityPermissions.includes(this.permission.id) ||
      this.userGlobalPermissions.includes(this.permission.id);
  },
  watch: {
    selected: function (oldStat, newStat) {
      if (!newStat)
        this.$emit(
          this.permission.entitySpecific
            ? "addEntityPermission"
            : "addGlobalPermission",
          this.permission.id
        );
      else
        this.$emit(
          this.permission.entitySpecific
            ? "removeEntityPermission"
            : "removeGlobalPermission",
          this.permission.id
        );
    },
  },
};
</script>

<style lang="scss">
</style>
